export default __webpack_public_path__ + "static/media/mockup-web.ca823e34.png";